export const EDITOR_SYSTEM  = 'Default';   
export const ITEMS_PER_PAGE = 10;           
